/*-----/translation api/------*/
export const FETCH_TRANS = "FETCH_TRANS";
export const FETCH_TRANS_PENDING = "FETCH_TRANS_PENDING";
export const FETCH_TRANS_REJECTED = "FETCH_TRANS_REJECTED";
export const FETCH_TRANS_FULFILLED = "FETCH_TRANS_FULFILLED";
/*-----/tour status api/------*/
export const FETCH_TOUR_STATUS = "FETCH_TOUR_STATUS";
export const FETCH_TOUR_STATUS_PENDING = "FETCH_TOUR_STATUS_PENDING";
export const FETCH_TOUR_STATUS_REJECTED = "FETCH_TOUR_STATUS_REJECTED";
export const FETCH_TOUR_STATUS_FULFILLED = "FETCH_TOUR_STATUS_FULFILLED";
/*-----/formation api/------*/
export const FETCH_FIXTURES = "FETCH_FIXTURES";
export const FETCH_FIXTURES_PENDING = "FETCH_FIXTURES_PENDING";
export const FETCH_FIXTURES_REJECTED = "FETCH_FIXTURES_REJECTED";
export const FETCH_FIXTURES_FULFILLED = "FETCH_FIXTURES_FULFILLED";
/*-----/get userPlayedGameDays api/------*/
export const FETCH_USER_PLAYED_GAMEDAYS = "FETCH_USER_PLAYED_GAMEDAYS";
export const FETCH_USER_PLAYED_GAMEDAYS_PENDING =
  "FETCH_USER_PLAYED_GAMEDAYS_PENDING";
export const FETCH_USER_PLAYED_GAMEDAYS_REJECTED =
  "FETCH_USER_PLAYED_GAMEDAYS_REJECTED";
export const FETCH_USER_PLAYED_GAMEDAYS_FULFILLED =
  "FETCH_USER_PLAYED_GAMEDAYS_FULFILLED";
/*-----/get questions api/------*/
export const FETCH_MTACH_QUESTIONS = "FETCH_MTACH_QUESTIONS";
export const FETCH_MTACH_QUESTIONS_PENDING = "FETCH_MTACH_QUESTIONS_PENDING";
export const FETCH_MTACH_QUESTIONS_REJECTED = "FETCH_MTACH_QUESTIONS_REJECTED";
export const FETCH_MTACH_QUESTIONS_FULFILLED =
  "FETCH_MTACH_QUESTIONS_FULFILLED";
/*-----/get answers api/------*/
export const FETCH_MTACH_USER_ANSWER = "FETCH_MTACH_USER_ANSWER";
export const FETCH_MTACH_USER_ANSWER_PENDING =
  "FETCH_MTACH_USER_ANSWER_PENDING";
export const FETCH_MTACH_USER_ANSWER_REJECTED =
  "FETCH_MTACH_USER_ANSWER_REJECTED";
export const FETCH_MTACH_USER_ANSWER_FULFILLED =
  "FETCH_MTACH_USER_ANSWER_FULFILLED";
/*-----/get answers post api/------*/
export const POST_MTACH_USER_ANSWER = "POST_MTACH_USER_ANSWER";
export const POST_MTACH_USER_ANSWER_PENDING = "POST_MTACH_USER_ANSWER_PENDING";
export const POST_MTACH_USER_ANSWER_REJECTED =
  "POST_MTACH_USER_ANSWER_REJECTED";
export const POST_MTACH_USER_ANSWER_FULFILLED =
  "POST_MTACH_USER_ANSWER_FULFILLED";
/*-----/get booster post api/------*/
export const POST_MTACH_USER_BOOSTER = "POST_MTACH_USER_BOOSTER";
export const POST_MTACH_USER_BOOSTER_PENDING =
  "POST_MTACH_USER_BOOSTER_PENDING";
export const POST_MTACH_USER_BOOSTER_REJECTED =
  "POST_MTACH_USER_BOOSTER_REJECTED";
export const POST_MTACH_USER_BOOSTER_FULFILLED =
  "POST_MTACH_USER_BOOSTER_FULFILLED";

/*-----/get booster post api/------*/
export const POST_CREATE_LEAGUE = "POST_CREATE_LEAGUE";
export const POST_CREATE_LEAGUE_PENDING = "POST_CREATE_LEAGUE_PENDING";
export const POST_CREATE_LEAGUE_REJECTED = "POST_CREATE_LEAGUE_REJECTED";
export const POST_CREATE_LEAGUE_FULFILLED = "POST_CREATE_LEAGUE_FULFILLED";

/*-----/get booster post api/------*/
export const POST_JOIN_LEAGUE = "POST_JOIN_LEAGUE";
export const POST_JOIN_LEAGUE_PENDING = "POST_JOIN_LEAGUE_PENDING";
export const POST_JOIN_LEAGUE_REJECTED = "POST_JOIN_LEAGUE_REJECTED";
export const POST_JOIN_LEAGUE_FULFILLED = "POST_JOIN_LEAGUE_FULFILLED";

/*-----/get booster post api/------*/
export const POST_APPLY_JOKER = "POST_APPLY_JOKER";
export const POST_APPLY_JOKER_PENDING = "POST_APPLY_JOKER_PENDING";
export const POST_APPLY_JOKER_REJECTED = "POST_APPLY_JOKER_REJECTED";
export const POST_APPLY_JOKER_FULFILLED = "POST_APPLY_JOKER_FULFILLED";
/*-----/get booster post api/------*/

/*-----/get get points api/------*/
export const FETCH_MTACH_USER_POINTS = "FETCH_MTACH_USER_POINTS";
export const FETCH_MTACH_USER_POINTS_PENDING =
  "FETCH_MTACH_USER_POINTS_PENDING";
export const FETCH_MTACH_USER_POINTS_REJECTED =
  "FETCH_MTACH_USER_POINTS_REJECTED";
export const FETCH_MTACH_USER_POINTS_FULFILLED =
  "FETCH_MTACH_USER_POINTS_FULFILLED";
/*-----/get get constraints api/------*/
export const FETCH_CONTRAINTS = "FETCH_CONTRAINTS";
export const FETCH_CONTRAINTS_PENDING = "FETCH_CONTRAINTS_PENDING";
export const FETCH_CONTRAINTS_REJECTED = "FETCH_CONTRAINTS_REJECTED";
export const FETCH_CONTRAINTS_FULFILLED = "FETCH_CONTRAINTS_FULFILLED";
/*-----/get get mix api/------*/
export const FETCH_MIX = "FETCH_MIX";
export const FETCH_MIX_PENDING = "FETCH_MIX_PENDING";
export const FETCH_MIX_REJECTED = "FETCH_MIX_REJECTED";
export const FETCH_MIX_FULFILLED = "FETCH_MIX_FULFILLED";
/*-----/get get leaderboard api/------*/
export const FETCH_LEADERBOARD = "FETCH_LEADERBOARD";
export const FETCH_LEADERBOARD_PENDING = "FETCH_LEADERBOARD_PENDING";
export const FETCH_LEADERBOARD_REJECTED = "FETCH_LEADERBOARD_REJECTED";
export const FETCH_LEADERBOARD_FULFILLED = "FETCH_LEADERBOARD_FULFILLED";
/*-----/get get leaderboard rank api/------*/
export const FETCH_LEADERBOARD_RANK = "FETCH_LEADERBOARD_RANK";
export const FETCH_LEADERBOARD_RANK_PENDING = "FETCH_LEADERBOARD_RANK_PENDING";
export const FETCH_LEADERBOARD_RANK_REJECTED =
  "FETCH_LEADERBOARD_RANK_REJECTED";
export const FETCH_LEADERBOARD_RANK_FULFILLED =
  "FETCH_LEADERBOARD_RANK_FULFILLED";

export const CHANGE_SELECTED_FIXTURE = "CHANGE_SELECTED_FIXTURE";
export const SET_DATA_AFTER_POST = "SET_DATA_AFTER_POST";
export const SET_DATA_ALERT = "SET_DATA_ALERT";
export const CLEAR_DATA_QUESTIONS = "CLEAR_DATA_QUESTIONS";
export const SET_WRAPPER_REF = "SET_WRAPPER_REF";

/*-----/get user leagues api/-----*/
export const FETCH_USER_LEAGUES = "FETCH_USER_LEAGUES";

/*-----/login post api/------*/
export const POST_LOGIN = "POST_LOGIN";
export const POST_LOGIN_PENDING = "POST_LOGIN_PENDING";
export const POST_LOGIN_REJECTED = "POST_LOGIN_REJECTED";
export const POST_LOGIN_FULFILLED = "POST_LOGIN_FULFILLED";

export const UPDATE_QUESTION_STATUS = "UPDATE_QUESTION_STATUS";

/*-----/get get leaderboard api/------*/
export const FETCH_BALANCE = "FETCH_BALANCE";
export const FETCH_BALANCE_PENDING = "FETCH_BALANCE_PENDING";
export const FETCH_BALANCE_REJECTED = "FETCH_BALANCE_REJECTED";
export const FETCH_BALANCE_FULFILLED = "FETCH_BALANCE_FULFILLED";
